export enum ApiLessonStatus {
  Initializing,
  Booked,
  Due,
  InProgress,
  Complete,
  Cancel,
  InvalidatedByTeacher,
  InvalidatedByStudent
}

export enum LessonFlagTargetType {
  Lesson,
  Teacher,
  Student
}

export class ApiBase {
  id: number;
}

export class ApiCasaBase {
  id: number;
  modifyDate: Date;
  lastSyncDate: Date;
}

export class ApiPersonBase extends ApiCasaBase {
  name: string;
  surname: string;
  accountId: number;
  emailAddress: string;
}

export class ApiPerson<T extends ApiPersonalProfileBase> extends ApiPersonBase {
  personalProfile: T;
}

export class ApiLearningUnitTeacherBase extends ApiCasaBase {
}

export class ApiLearningUnitTeacher extends ApiLearningUnitTeacherBase {
  person: ApiPerson<ApiPersonalProfileBaseWithPhoto>;
  status: string;
}

export class ApiLearningUnitStudentBase extends ApiCasaBase {
}

export class ApiLearningUnitStudent<P extends ApiPersonBase> extends ApiLearningUnitStudentBase {
  person: P;
}

export class ApiLessonMetric {
  plannedStartDate: Date;
  started: Date;
  plannedDuration: number;
  duration: number;
  timezone: string;
}

export class ApiLessonCancellationDetails {
  cancelationDate: Date;
  cancelledByTeacher: boolean;
  cancellationReason: String;
}

export class ApiLessonInstanceBase extends ApiBase {
  lessonStatus: string;
  lessonType: string;
  createDate: Date;
  lessonMetric: ApiLessonMetric;
  cancellationDetails: ApiLessonCancellationDetails;
}

export class ApiLessonProgress extends ApiBase {
  start: number;
  reading: number;
  nwp: number;
  hw: string;

  productCode: string;
  courseCode: string;

  courseProgress: number;
  productProgress: number;
}

export class ApiLessonMessage {
  lessonComment: string;
  privateLessonComment: string;
  message: string;
}

export class ApiFile extends ApiBase {
  uploadOriginalName: string;
  name: string;
  contentType: string;
  variantName: string;
  size: number;
  resourceKey: string;
  uploadDate: string;
  accessToken: string;
}

export class ApiPersonalProfileBase extends ApiBase {
  biography: string;
  name: string;
  surname: string;
  email: string;
  nationality: string;
  gender: string;
  reasonForStuding: string;
  birthPlace: string;
  birthDate: Date;
  nationalityIso: number;
  countryIso: number;
}

export class ApiPersonalProfileBaseWithPhoto extends ApiPersonalProfileBase {
  profilePhoto: ApiFile;
}

export class ApiPersonalProfile extends ApiPersonalProfileBaseWithPhoto {
  person: ApiPersonBase;
}

export class ApiLessonFlag extends ApiBase {

  static StatusSolved = 'Solved';
  static StatusSubmitted = 'Submitted';
  static TargetLesson = 'Lesson';
  static TargetTeacher = 'Teacher';
  static TargetStudent = 'Student';
  static FtPoorConnection = 'PoorConnection';
  static FtClassroomIssue = 'ClassroomIssue';
  static FtStudentNeedsHelp = 'StudentNeedsHelp';
  static FtStudentNotShow = 'StudentNotShow';
  static FtTeacherNotShow = 'TeacherNotShow';
  static FtOther = 'Other';
  static flagsTypes = [
    ApiLessonFlag.FtPoorConnection,
    ApiLessonFlag.FtClassroomIssue,
    ApiLessonFlag.FtStudentNeedsHelp,
    ApiLessonFlag.FtOther,
  ];
  static descriptionRequiringFlags = [
    ApiLessonFlag.FtStudentNeedsHelp,
    ApiLessonFlag.FtOther,
  ];
  static allFlagTypes = [
    ApiLessonFlag.FtPoorConnection,
    ApiLessonFlag.FtClassroomIssue,
    ApiLessonFlag.FtStudentNeedsHelp,
    ApiLessonFlag.FtStudentNotShow,
    ApiLessonFlag.FtTeacherNotShow,
    ApiLessonFlag.FtOther,
  ];
  flagType: string;
  date: Date;
  description: string;
  solveDate: Date;
  solveDetails: string;
  status: string;
  target: LessonFlagTargetType;

  static getFLagDescription(type: string) {
    if (type === ApiLessonFlag.FtClassroomIssue) {
      return 'Classroom issue';
    } else if (type === ApiLessonFlag.FtOther) {
      return 'Other';
    } else if (type === ApiLessonFlag.FtPoorConnection) {
      return 'Poor connection';
    } else if (type === ApiLessonFlag.FtStudentNeedsHelp) {
      return 'Student neeeds help';
    } else if (type === ApiLessonFlag.FtStudentNotShow) {
      return 'Student no Show';
    } else if (type === ApiLessonFlag.FtTeacherNotShow) {
      return 'Teacher no show';
    } else { return 'Unknown'; }
  }
}

export abstract class ApiLessonInstancePreviewBase extends ApiLessonInstanceBase {
  progressCommited: ApiLessonProgress;
  course: { name: string; code: string };
  competence: { name: string; code: string };
}

export class ApiLessonInstance<S extends ApiPersonalProfileBase, T extends ApiLearningUnitTeacherBase>
  extends ApiLessonInstancePreviewBase {
  teacher: T;
  students: ApiLearningUnitStudent<ApiPerson<S>>[];
  message: ApiLessonMessage;
  flags: ApiLessonFlag[];
  studentMessage: string;
  roomUrl: string;
  productVersion: string;
}

